import { APP_BASE_HREF, CommonModule, DatePipe, registerLocaleData } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoginComponent } from '@business/login/login.component';
import { RecoverPasswordComponent } from '@business/recover-password/recover-password.component';
import { CustomSnackbarComponent } from '@component/custom-snackbar/custom-snackbar.component';
import { CustomWorkspaceModalComponent } from '@component/custom-workspace-modal/custom-workspace-modal.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AUTH_STRATEGY_LOGIN } from '@services/authentication.service';
import { ConfigurationService } from '@services/configuration.service';
import { CustomSnackbarService } from '@services/custom-snackbar-service.service';
import { SharedModule } from '@shared/shared.module';
import { AgGridModule } from 'ag-grid-angular';
import { NotificationsService, SimpleNotificationsModule } from 'angular2-notifications';
import { environment } from 'src/environments/environment';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing.module';
import { CoreModule } from './core/core.module';
import { AdapterAuthStrategyService } from './core/services/adapter-auth-strategy.service';
import { SaasAuthStrategyService } from './core/services/saas-auth-strategy.service';
import { Wso2AuthStrategyService } from './core/services/wso2-auth-strategy.service';
import { RegisterModule } from './register/register.module';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

import { OAuthModule } from 'angular-oauth2-oidc';
import { IAMAuthService } from './core/services/iam-auth.service';



export function initApp(cfg: ConfigurationService, auth: IAMAuthService) {
  return async () => {
    // 1) carrega config externa
    await cfg.load(environment.CONFIG_FILE);
    // 2) só então inicializa autenticação
    await auth.init();
  };
}

registerLocaleData(localePt);

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    CustomSnackbarComponent,
    RecoverPasswordComponent,
  ],
  imports: [
    AppRoutingModule,
    CoreModule,
    CommonModule,
    BrowserAnimationsModule,
    SharedModule,
    RegisterModule,
    SimpleNotificationsModule.forRoot(),
    OAuthModule.forRoot({
      resourceServer: {
        allowedUrls: [
          'https://api-qa.cedrotech.com',
          'https://apis-portal-uat.stonex.dev',
          'https://apis-portal.stonex.com',
          '/workspace-api',
          '/api',
          '/webfeeder',
          ...environment.OAUTH_ALLOWED_URLS
        ],
        sendAccessToken: true,
      },
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    AgGridModule.withComponents([]),
    NgbModule
  ],
  entryComponents: [
    LoginComponent,
    CustomSnackbarComponent,
    RecoverPasswordComponent
  ],
  exports: [
    CustomWorkspaceModalComponent
  ],
  providers: [
     {
      provide: APP_INITIALIZER,
      useFactory: initApp,
      deps: [ConfigurationService, IAMAuthService],
      multi: true,
    },
    { provide: APP_BASE_HREF, useValue: environment.BASE_HREF },
    {
      provide: AUTH_STRATEGY_LOGIN, useFactory: (
        wso2: Wso2AuthStrategyService,
        adapter: AdapterAuthStrategyService,
        saas: SaasAuthStrategyService,
        iam: IAMAuthService,
      ) => {
        if (environment.LOGIN_SERVICE === 'WSO2AuthStrategy') {
          return wso2;
        } else if (environment.LOGIN_SERVICE === 'AdapterAuthStrategy') {
          return adapter;
        } else if (environment.LOGIN_SERVICE === 'SaasAuthStrategy') {
          return saas;
        } else if (environment.LOGIN_SERVICE === 'IAMAuthStrategy') {
          return iam;
        }
        return new Error('Nenhum metodo de autenticação selecionado');
      },
      deps: [
        Wso2AuthStrategyService,
        AdapterAuthStrategyService,
        SaasAuthStrategyService,
        IAMAuthService,
      ]
    },
    ConfigurationService,
    // {
    //   provide: Sentry.TraceService,

    // },

    NotificationsService,
    CustomSnackbarService,
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    DatePipe,
    // { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_LEGACY_DATE_LOCALE_FACTORY] },
    {provide: MAT_DATE_LOCALE, useValue: 'pt-BR'},
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
